import React, { useEffect, useMemo, useState } from 'react';
import { Guide } from '@/pages/home/components/Guide';
import { getLocale, useSelector, useDispatch, useLocation, history, useIntl } from 'umi';
import { storage } from '@/utils/utils'
import { GUIDE_SYS_DASHBOARD, GUIDE_TYPE_DASHBOARD_SUBSCRIBE } from '@/pages/home/models/guide';
import {
  DASHBOARD_GUIDE_BOX_LIST5,
  DASHBOARD_GUIDE_HIDE,
  DASHBOARD_SHOW_GUIDE_GAME_LIST,
} from '@/pages/home/components/GuideModule/GuideDashboardBox';

import guideImg_5_1_cn from '@/pages/dashboard/assets/images/guide/cn/guide-dbd-feature5-1.png';
import guideImg_5_1_en from '@/pages/dashboard/assets/images/guide/en/guide-dbd-feature5-1.png';
import guideImg_5_2_cn from '@/pages/dashboard/assets/images/guide/cn/guide-dbd-feature5-2.png';
import guideImg_5_2_en from '@/pages/dashboard/assets/images/guide/en/guide-dbd-feature5-2.png';

import './index.scss';

const GuideSubscribe = (props: any) => {
  const [currentGuideStep, setCurrentGuideStep] = useState(-3);
  const locale = getLocale();
  const { formatMessage } = useIntl();
  const isEn = locale === 'en-US';
  const dispatch = useDispatch();
  const location = useLocation();
  const { guideType, userInfo } = useSelector((state: any) => {
    const { guide: { guideType }, home: { userInfo } } = state;
    return {
      guideType,
      userInfo
    }
  });

  // 注意下面两个useEffect不要合并到一起，不然会出现：从头部导航进入新手引导，点击到下一步时，关闭按钮无法关闭，而是返回到第一步
  useEffect(() => {
    if (guideType === GUIDE_TYPE_DASHBOARD_SUBSCRIBE) {
      setCurrentGuideStep(0);
    }
  }, [guideType]);

  useEffect(() => {
    const list = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST5) || [];
    const guideHide = storage.getLocalStorageItem(DASHBOARD_GUIDE_HIDE);
    if (userInfo?.openid && !list.includes(userInfo.openid) && !guideHide) {
      setCurrentGuideStep(0);
    }
  }, [userInfo])

  const steps = useMemo(() => {
    return [
      {
        highlightElements: [],
        element: () =>
          document.getElementsByClassName('menu-overview-daily')?.[0],
        hasRadius: false,
        title: formatMessage({ id: 'guide_subscribe_step1_title' }),
        subtitle: formatMessage({ id: 'guide_subscribe_step1_subtitle' }),
        description: formatMessage({ id: 'guide_subscribe_step1_description' }),
        placement: 'right',
        bubbleStyle: { left: '168px', top: '4px' },
        extImage: {
          image: isEn ? guideImg_5_1_en : guideImg_5_1_cn,
          placement: 'right-start',
          style: { width: '160px', left: '-8px', position: 'relative' },
        },
      },
      {
        highlightElements: [],
        element: () =>
          document.getElementsByClassName(
            'js-guide-subscribesetting-frequency-select',
          )?.[0],
        title: formatMessage({ id: 'guide_subscribe_step2_title' }),
        subtitle: formatMessage({ id: 'guide_subscribe_step2_subtitle' }),
        description: formatMessage({ id: 'guide_subscribe_step2_description' }),
        placement: 'right-center',
        extImage: {
          image: isEn ? guideImg_5_2_en : guideImg_5_2_cn,
          placement: 'bottom-start',
          style: { width: '140px' },
        },
      },
    ];
  }, [currentGuideStep, locale]);

  // 流程完成后保存至local storage
  const updateGuideCompletionStatus = () => {
    if (userInfo.openid) {
      const list = storage.getLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST5) || [];
      !list?.includes(userInfo.openid) &&  list.push(userInfo.openid);
      storage.setLocalStorageItem(DASHBOARD_GUIDE_BOX_LIST5, list);
    }
  };

  const onCloseStep = () => {
    updateGuideCompletionStatus();

    dispatch({
      type: 'guide/save',
      payload: {
        guideSys: GUIDE_SYS_DASHBOARD,
        guideType: '',
      },
    });
  }

  const onFinished = () => {
    updateGuideCompletionStatus();
    
    dispatch({
      type: 'guide/showDashboardGuideModule',
      payload: true,
    });
  }
  return (
    // finishText 根据中英文调整
    <Guide
      current={currentGuideStep}
      onCurrentChange={(
        current: number,
        context: { from: 'start' | 'back' | 'next' | 'finish' | 'cancel' },
      ) => {
        const { from } = context;
        setCurrentGuideStep(current);
        if (from === 'finish') {
          onFinished();
        } else if (from === 'cancel') {
          onCloseStep();
        }
      }}
      visibleCloseBtn
      hideCancelButton
      showBackButton
      nextButtonTheme="primary"
      backText={formatMessage({ id: 'guide_last_step' })}
      nextText={formatMessage({ id: 'guide_next_step' })}
      finishText={formatMessage({ id: 'guide_more_step' })}
      steps={steps}
    />
  );
};

export default () => {
  const { currentGame } = useSelector(state => {
    // @ts-ignore
    const { currentGame } = state.dashboard;
    return {
      currentGame
    }
  });

  return <>
    {currentGame && DASHBOARD_SHOW_GUIDE_GAME_LIST.includes(currentGame.game_code) && <GuideSubscribe />}
  </>
}
